import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import App from './App';
import createAdminPortalRoutes from './routes/adminPortalRoutes';
import createBillerPortalRoutes from './routes/billerPortalRoutes';
import createCarePortalRoutes from './routes/carePortalRoutes';
import createEhrRoutes from './routes/ehrRoutes';
import createInternalToolRoutes from './routes/internalToolRoutes';
import createSampleRoutes from './routes/sampleRoutes';

const ResetPasswordComponent = lazy(() => import('./features/auth/component/ResetPasswordComponent/ResetPasswordComponent'));
const UserActivationContainer = lazy(() => import('./features/adminPortal2/container/UserActivationContainer/UserActivationContainer'));
const DexcomLinkDonePage = lazy(() => import('./features/dexcomLink/component/DexcomLinkDonePage'));
const PageError = lazy(() => import('./PageError'));

export const RoutesComponent = () => (
  <Suspense fallback={<div>loading...</div>}>
    <Routes>
      <Route path="/dexcom" element={<DexcomLinkDonePage />} />
      <Route path="/">
        <Route index element={<App />} />
        <Route path="/reset-password" element={<ResetPasswordComponent />} />
        <Route path="/onboard-password" element={<UserActivationContainer />} />
        {createEhrRoutes()}
        {createAdminPortalRoutes()}
        {createCarePortalRoutes()}
        {createBillerPortalRoutes()}
        {createInternalToolRoutes()}
        {createSampleRoutes()}
        <Route path="/403" element={<PageError message="Unauthorized Access" />} />
        <Route path="*" element={<PageError message="Unknown page" />} />
      </Route>
    </Routes>
  </Suspense>
);
